import { render, staticRenderFns } from "./RecuperarClave.vue?vue&type=template&id=13486b79&scoped=true"
import script from "./RecuperarClave.vue?vue&type=script&lang=js"
export * from "./RecuperarClave.vue?vue&type=script&lang=js"
import style0 from "./RecuperarClave.vue?vue&type=style&index=0&id=13486b79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13486b79",
  null
  
)

export default component.exports